import { render, staticRenderFns } from "./Casier.vue?vue&type=template&id=98e094fe&scoped=true&"
import script from "./Casier.vue?vue&type=script&lang=ts&"
export * from "./Casier.vue?vue&type=script&lang=ts&"
import style0 from "./Casier.vue?vue&type=style&index=0&id=98e094fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e094fe",
  null
  
)

export default component.exports